<div *ngIf="!loading">
  <p-timeline
    [value]="events"
    align="alternate"
    styleClass="customized-timeline"
  >
    <ng-template pTemplate="marker" let-event>
      <span
        class="custom-marker shadow-2"
        [style.backgroundColor]="event.color"
      >
        <i [ngClass]="event.icon"></i>
      </span>
    </ng-template>
    <ng-template pTemplate="content" let-event>
      <!-- [subheader]="event.date" -->
      <p-card [header]="event.status">
        <img
          *ngIf="event.image"
          [src]="event.image"
          [alt]="event.name"
          width="200"
          class="shadow-2 mb-2"
          style="border-radius: 10px;"
        />
        <p>{{ event.description }}</p>
        <div
          [pTooltip]="
            !disabledButton(event.flag) || event.finish ? '' : event.toolTip
          "
        >
          <button
            pButton
            pRipple
            [icon]="
              disabledButton(event.flag)
                ? 'pi pi-spin pi-clock'
                : 'pi pi-fw pi-pencil'
            "
            [label]="
              disabledButton(event.flag)
                ? 'Preencha o passo anterior'
                : 'Inserir informações'
            "
            iconPos="right"
            *ngIf="!event.finish"
            class="p-button-outlined p-button-rounded mt-2 cursor-pointer"
            [disabled]="disabledButton(event.flag)"
            (click)="sendTo(event.flag)"
          ></button>
          <div class="" *ngIf="event.finish">
            <button
              pButton
              pRipple
              icon="pi pi-fw pi-pencil"
              label="Editar informações"
              iconPos="right"
              (click)="sendTo(event.flag)"
              class="p-button-outlined p-button-rounded mt-2 p-button-primary"
            ></button>
            <i class="pi pi-fw pi-check-circle mb-3 ml-2 cursor-pointer" style="color: green;" pTooltip="Passo finalizado!"></i>
          </div>
        </div>
      </p-card>
    </ng-template>
  </p-timeline>
</div>
